// extracted by mini-css-extract-plugin
module.exports = {"flameIcon":"_de2e2c0","flameIconBadge":"_59b6188"};